import type { TranslationKey } from "../locales";
import type { Nullable } from "../types";
import type { ProtocolType } from "../types/protocols";

export function getProtocolTypeTranslationKey(
	template: Nullable<ProtocolType | string>,
): TranslationKey {
	switch (template) {
		case "general":
			return "protocols.general";
		case "meeting":
			return "protocols.meeting";
		case "negotiation":
			return "protocols.negotiation";
		case "call-request":
			return "protocols.call_request";
		default:
			return "protocols.protocol";
	}
}
